import { Button } from '@insio/ui-toolkit';

/** Shared clear (×) button rendered inside Input's rightContent slot. */
export function ClearInputButton({
  onClick,
  testId,
  ariaLabel
}: {
  onClick: () => void;
  testId: string;
  ariaLabel: string;
}) {
  return (
    <Button
      variant='default'
      size='icon'
      icon='xmark'
      onClick={onClick}
      testId={testId}
      aria-label={ariaLabel}
      className='text-foreground-muted hover:text-foreground-base'
    />
  );
}
